import isNumber from 'lodash.isnumber';

import {NumberFormat} from '../number';

import type {Locale, Options} from '../number';


export class SequenceFormat extends NumberFormat {
    constructor(
        decimals: number,
        showZeros: boolean,
        negativeParenthesis: boolean = false,
    ) {
        super(decimals, showZeros, negativeParenthesis);
    }

    format(
        value: number | null | undefined,
        locale?: Locale,
        options?: Options,
    ) {
        if (value === 0 && !this.showZeros) {
            return '';
        }

        if (!isNumber(value)) {
            return '';
        }

        const lastTwoNumber = value % 100;
        let suffix;

        if (
            lastTwoNumber === 11 ||
            lastTwoNumber === 12 ||
            lastTwoNumber === 13
        ) {
            suffix = 'th';
        } else {
            switch (value % 10) {
                case 1:
                    suffix = 'st';
                    break;

                case 2:
                    suffix = 'nd';
                    break;

                case 3:
                    suffix = 'rd';
                    break;

                default:
                    suffix = 'th';
            }
        }

        return super.format(value, locale, options).concat(suffix);
    }
}
